import React, {useContext, useEffect, useRef, useState} from "react";
import OptionCountry from "./RegistrationForm/OptionCountry";
import InputMask from "react-input-mask";
import {Context} from "../../../../../index";
import {observer} from "mobx-react-lite";
import {phoneCountryArr} from "../../../../../utils/consts";
import ButtonUI from "../../../../UI/ButtonUI/ButtonUI";
import {ReactComponent as ArrowIcon} from "../../../../../assets/icons/arrow_bottom.svg";
import clsx from "clsx";

const RegistrateStep = observer((props) => {
    const inputRef = useRef(null);
    const {user} = useContext(Context);
    const [searchStateShow, setSearchStateShow] = useState("unactive");
    const [maskState, setMaskState] = useState(phoneCountryArr[0]);
    const [isLoading, setIsLoading] = useState(false);
    const [localError, setLocalError] = useState("");

    const setTelephoneCheckButton = (number) => {
        const replacenumber = number.replace(/[^\d]/g, "");
        user.setPhoneNumber(number);
        user.setGetMeCodeButton(
            Number(replacenumber.length) === Number(maskState.number)
                ? "active"
                : "unactive"
        );

        if (localError) setLocalError("");
    };

    const ToggleShowContry = () => {
        setSearchStateShow(
            searchStateShow === "unactive" ? "active" : "unactive"
        );
    };

    const changeModelInput = (object) => {
        setMaskState(object);
        setTelephoneCheckButton("");
        ToggleShowContry();
        user.setCountry(object.name);
        if (localError) setLocalError("");
    };

    const isPhoneValid = () => {
        const phoneDigits = user.phoneNumber.replace(/[^\d]/g, "");
        return phoneDigits.length === Number(maskState.number);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!isPhoneValid()) {
            setLocalError("Введите корректный номер телефона");
            return;
        }

        setIsLoading(true);
        setLocalError("");

        try {
            await props.registrationFunc();
        } catch (error) {
            setLocalError(error.message || "Ошибка отправки");
        } finally {
            setIsLoading(false);
        }
    };

    const getCountryCode = (mask) => {
        const match = mask.match(/\+(\d+)/);
        if (match && match[1]) {
            return `+${match[1]}`;
        }
        return mask.split(" ")[0];
    };

    const checkToggler = (e) => {
        if (e.target.closest(".phone_and_city_wrap") === null) {
            setSearchStateShow("unactive");
        }
    };

    const goToRegistrationForm = () => {
        props.goToRegistrationForm();
    };

    useEffect(() => {
        if (user.stepModals === "registration" && user.openAuthModal === 1) {
            inputRef.current?.focus();
        }
    }, [user.openAuthModal, user.stepModals]);

    const errorText = localError || props.codeLimitErrorText;

    return (
        <form
            onSubmit={handleSubmit}
            onClick={checkToggler}
            className={"registration_form " + props.controllStateClass}
        >
            <div className={"fields_register_and_politic"}>
                <span className={"fields_register_and_politic_title"}>
                    Авторизация
                </span>
                <span className={"small_text_registration"}>
                    Введите номер телефона, пришлем СМС
                    с&nbsp;кодом&nbsp;подтверждения
                </span>
                <div className={"fields_register_wrapper"}>
                    <div className={"registration_select_class"}>
                        <div className={"phone_and_city_wrap"}>
                            <div
                                onClick={() => ToggleShowContry()}
                                className={"selected_input_wrapper"}
                            >
                                <img
                                    className={"selected_input_wrapper__img"}
                                    src={maskState.imgPath}
                                    alt=""
                                />
                                <span className="country-name">
                                    {maskState.name}
                                </span>
                                <div
                                    className={clsx(
                                        "selected_input_wrapper-icon",
                                        {
                                            "selected_input_wrapper-icon--active":
                                                searchStateShow === "active",
                                        }
                                    )}
                                >
                                    <ArrowIcon />
                                </div>
                            </div>
                            <div className={"searchResults " + searchStateShow}>
                                {searchStateShow === "active" && phoneCountryArr.map((country, index) => (
                                    <OptionCountry
                                        onClick={() =>
                                            changeModelInput(country)
                                        }
                                        key={index}
                                        country={country}
                                    />
                                ))}
                            </div>
                        </div>
                        <div className="phone-input-container">
                            <span className="phone-label">Телефон</span>
                            <InputMask
                                className="phoneInput"
                                placeholder={getCountryCode(
                                    maskState.placeholder
                                )}
                                mask={maskState.mask}
                                value={user.phoneNumber}
                                onChange={(e) =>
                                    setTelephoneCheckButton(e.target.value)
                                }
                                maskChar={null}
                            >
                                {(inputProps) => (
                                    <input
                                        {...inputProps}
                                        ref={inputRef}
                                        type="tel"
                                        disableUnderline
                                    />
                                )}
                            </InputMask>
                        </div>
                    </div>
                    <ButtonUI
                        className={"app_telephone_auth__button"}
                        type={"submit"}
                        text={isLoading ? "Отправка..." : "Получить код"}
                        disabled={!isPhoneValid() || isLoading}
                    />
                    {props.captchaNode}
                    <div
                        className={"select_politic_type_error"}
                        dangerouslySetInnerHTML={{
                            __html: errorText,
                        }}
                    />

                    <div className="auth_switch_link">
                        <span onClick={goToRegistrationForm}>
                            Еще нет аккаунта?
                            <span className="auth_switch_link__highlight">
                                Зарегистрироваться
                            </span>
                        </span>
                    </div>
                </div>
                <div className={"politic_wrap"}>
                    <span className={"politic_wrap__text"}>
                        Нажимая на&nbsp;кнопку &laquo;Получить код&raquo;,
                        я&nbsp;даю согласие на&nbsp;обработку своих персональных
                        данных в соответствии с{" "}
                        <a target={"_blank"} href="/personal/privacy-policy/">
                            Политикой обработки персональных данных
                        </a>
                    </span>
                </div>
            </div>
        </form>
    );
});

export default RegistrateStep;
